import React from 'react';
import classnames from 'classnames';
import { Checkbox as AntdCheckbox, CheckboxProps } from 'antd';
import type { CheckboxGroupProps } from 'antd/es/checkbox';

import './style.scss';

const PREFIX = 'music';

function Checkbox(props: CheckboxProps) {
  const { className, ...rstProps } = props;

  return (
    <AntdCheckbox
      {...rstProps}
      className={classnames(`${PREFIX}-checkbox`, className)}
    />
  );
}

function Group(props: CheckboxGroupProps) {
  const { className, ...rstProps } = props;

  return (
    <AntdCheckbox.Group
      {...rstProps}
      className={classnames(`${PREFIX}-checkbox-group`, className)}
    />
  );
}

Checkbox.Group = Group;

export default Checkbox;
